<footer class="bg-dark pl-2 pr-2 pl-md-4 pr-md-4 text-white font-12">
  <div class="row m-0 justify-content-center">
    <span>Copyright © {{date | date: 'yyyy'}} <a routerLink="/" class="font-yesteryear text-white font-24">yakoota.</a> Tout droit réservé.</span>
  </div>
</footer>
